// @ai-generated 2026-08-10T06:52:00+00:00 by niklas.eicker@tngtech.com using Claude Opus 5
import { AUFTRAG_API } from '@Constants/backendConstants';
import { useRemoteCacheInvalidation } from '@Hooks/useRemoteCacheInvalidation';
import { useChildListApi } from '@Hooks/useListApi';
import { RequisitionOrdersRepository } from '@Repositories/Auftragsbearbeitung';
import { EnumDirection } from '@synqo/frontend-component-library';
import { useQuery } from '@tanstack/react-query';

const MAX_SNAPSHOTS = 50;

/**
 * The order snapshots linked to a requisition, oldest first. They are the only record of when a
 * requisition moved through its stages, so the portal timeline reads its dates from them.
 */
export function useRequisitionOrderSnapshots(requisitionId: string, enabled: boolean) {
    const { loadPage } = useChildListApi(RequisitionOrdersRepository, AUFTRAG_API, requisitionId);

    const { data, isLoading, refetch } = useQuery({
        queryFn: () =>
            loadPage({
                page_no: 0,
                page_size: MAX_SNAPSHOTS,
                full_text_search: '',
                sort_columns: [{ column_name: 'created_at', direction: EnumDirection.ASC }],
            }),
        queryKey: ['requisitions', requisitionId, 'orders'],
        enabled: enabled && requisitionId !== '',
    });

    useRemoteCacheInvalidation('requisitions', refetch);

    return {
        snapshots: data?.items,
        isLoading,
    };
}
